import { queryOptions } from '@tanstack/react-query'
import { apiFetch } from '@shared/api/http'
import { MembersAreaDetailSchema, MembersAreaListSchema } from './members-area.contract'
import type { MembersAreaDetail, MembersAreaListItem } from './members-area.contract'

export const VIDEO_POLL_MS = 5_000

export function hasPendingVideo(detail: MembersAreaDetail | undefined) {
  return Boolean(
    detail?.modules.some((module) =>
      module.lessons.some((lesson) => lesson.video?.status === 'PROCESSING'),
    ),
  )
}

export const membersAreaKeys = {
  all: ['members-area'] as const,
  lists: () => [...membersAreaKeys.all, 'list'] as const,
  detail: (productId: string) => [...membersAreaKeys.all, 'detail', productId] as const,
}

export function membersAreaListQuery() {
  return queryOptions({
    queryKey: membersAreaKeys.lists(),
    queryFn: async (): Promise<MembersAreaListItem[]> => {
      const data = await apiFetch<unknown>('/members-area/products')
      return MembersAreaListSchema.parse(data)
    },
  })
}

export function membersAreaDetailQuery(productId: string) {
  return queryOptions({
    queryKey: membersAreaKeys.detail(productId),
    queryFn: async (): Promise<MembersAreaDetail> => {
      const data = await apiFetch<unknown>(`/members-area/products/${productId}`)
      return MembersAreaDetailSchema.parse(data)
    },
    enabled: Boolean(productId),
    refetchInterval: (query) => (hasPendingVideo(query.state.data) ? VIDEO_POLL_MS : false),
  })
}
